import React from "react";
import { Input, InputGroup } from "reactstrap";
import { 
  getDetail as getDetailService,
  barcodeService
} from "../services/AutocompleteService";
import { getLoggedInUser } from "../services/AuthenticationService";
import {
  checkStatus,
  getApiUrl,
  getHeaderForAjax,
  parseJSON,
} from "../services/ServiceHelper";
// import { BARCODE_READ } from "../actions/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faPaperclip, faArrowRotateLeft } from "@fortawesome/pro-light-svg-icons";
import { Valert } from "../components";
import i18n from "../i18n";

const parseSuggestionName = (name = "") => {
  let s = String(name).trim();
  let sharedRank = -1;

  let changed = true;
  while (changed) {
    changed = false;

    // 1. Strip "Sup (C)" or "Sup(C)"
    const supMatch = s.match(/\s+sup\s?\((C)\)\s*$/i);
    if (supMatch) {
      s = s.replace(/\s+sup\s?\((C)\)\s*$/i, "").trim();
      changed = true;
      continue;
    }

    // 2. Strip marker (C), (CR), (CG)
    const markerMatch = s.match(/\s?\((C|CR|CG)\)\s*$/i);
    if (markerMatch) {
      s = s.replace(/\s?\((C|CR|CG)\)\s*$/i, "").trim();
      changed = true;
    }

    // 3. Strip shared suffix
    const sharedMatch = s.match(/\s*-\s*shared(?:\s+(\d+))?\s*$/i);
    if (sharedMatch) {
      sharedRank = sharedMatch[1] ? parseInt(sharedMatch[1], 10) : 0;
      s = s.replace(/\s*-\s*shared(?:\s+\d+)?\s*$/i, "").trim();
      changed = true;
    }
  }

  return {
    raw: String(name).trim(),
    base: s.toLocaleLowerCase(),
    sharedRank,
  };
};

class VautoCompelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      show: false,
      sval: "",
      delayTime: 500,
      pendingSearch: false,
      searchStatus: "idle",
      showMultipleMatchAlert: false,
      showExpandedValueOverlay: false,
    };
    this.internalSelect = this.internalSelect.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this.autoSelect = this.autoSelect.bind(this);
    this.delaySearch = this.delaySearch.bind(this);
    this.timer = null;
    this.inputEl = null;
    this._justSelected = false;
    this._barcodeMode = false;
    this._skipNextAutoSelect = false;
    this._suppressAutoSelectUntilRefocus = false;
    this._restoringFocusAfterPrompt = false;
  }

  searchStatus = (val) => {
    if (val) {
      this.setState({ searchStatus: val });
    }
    this.props.getSearchStatus
      ? this.props.getSearchStatus(val ? val : this.state.searchStatus)
      : null;
  };

  normalizeAutoName = (s = "") =>
    String(s)
      .trim()
      .toLocaleLowerCase()
      .replace(/\s*-\s*shared(?:\s+\d+)?$/i, "")
      .replace(/\s+\((c|cr|cg)\)$/i, " ($1)")
      .replace(/\((c|cr|cg)\)$/i, " ($1)");

  getPerfectMatches = (list, typedRaw) => {
    const typedTrimmed = String(typedRaw || "").trim();
    const typedExact = typedTrimmed.toLocaleLowerCase();

    const exactMatches = list.filter((item) => {
      const full = String(item && item.fullname ? item.fullname : "").trim();
      if (!full) return false;

      return full.toLocaleLowerCase() === typedExact;
    });

    // Step 1: if any exact match exists, use ONLY exact match result
    if (exactMatches.length > 0) {
      return exactMatches;
    }

    // Step 2: only if no exact match, fall back to suffix-removed comparison
    const typedNormalized = this.normalizeAutoName(typedTrimmed);
    const typedBase = parseSuggestionName(typedTrimmed).base;

    return list.filter((item) => {
      const full = String(item && item.fullname ? item.fullname : "").trim();
      if (!full) return false;

      const itemNormalized = this.normalizeAutoName(full);
      const itemBase = parseSuggestionName(full).base;

      return (
        itemNormalized === typedNormalized ||
        itemBase === typedBase
      );
    });
  };

  showMultiplePerfectMatchesPrompt = (list) => {
    this._skipNextAutoSelect = true;
    this._suppressAutoSelectUntilRefocus = true;
    this._restoringFocusAfterPrompt = true;

    this.setState({
      showMultipleMatchAlert: true,
      data: list,
      show: true,
      pendingSearch: false,
      showExpandedValueOverlay: false,
    });
  };

  handleMultipleMatchPrompt = () => {
    this.setState(
      { showMultipleMatchAlert: false },
      () => {
        // restore focus + suggestion list
        if (this.inputEl && document.activeElement !== this.inputEl) {
          this.inputEl.focus();
        }

        this.setState({
          show: true,
        });
      }
    );
  };

  searchCurrentValueForNewCategory = () => {
    const typed = String(this.props.val || "").trim();
    const category = String(this.props.category || "").trim();

    // Only for category-change scenario when item name already has text
    if (!typed || !category || this.props.append) return;

    clearTimeout(this.timer);
    this._fromHistoryClick = false;
    this._barcodeMode = false;
    this._justSelected = false;

    this.setState(
      {
        show: true,
        data: [],
        pendingSearch: true,
        sval: typed,
      },
      () => {
        this.search(
          typed,
          this.props.category,
          this.props.level,
          this.props.noUser,
          this.props.sType
        );
      }
    );
  };

  async search(val, type, level, noUser, sType) {
    this.setState({ pendingSearch: true });
    this.searchStatus("start");
    this.props.onSuggestStart && this.props.onSuggestStart();

    level = level || "111111";
    val = val.toLowerCase();
    let url = "";
    sType = sType ? sType : 4;
    if (noUser) {
      url = `${getApiUrl()}/lookup/typeaheadsearch/${type}/${sType}/${level}/${val}/20/1`;
    } else {
      const userId = getLoggedInUser()._id;
      url = `${getApiUrl()}/users/${userId}/typeaheadsearch/${type}/${sType}/${level}/${val}/20/1`;
    }

    return await fetch(url, {
      method: "GET",
      headers: getHeaderForAjax(),
    })
      .then(checkStatus)
      .then(parseJSON)

      .catch(() => {
        this.searchStatus("404");
        this.props.onSuggestFinish && this.props.onSuggestFinish(); 
        let data = {
          show: [],
          data: [],
        };
      })
      .then((data) => {

        // Normalize to objects with fullname
        const mapped = (Array.isArray(data) ? data : []).map(x =>
          typeof x === "string" ? { _id: x, fullname: x } : x
        );

        // Reorder: move exact match to the first position (typing only)
        const typed = (this.props.val || "").trim().toLocaleLowerCase();
        const inHistoryMode = !!this._fromHistoryClick;
        const inBarcodeMode = !!this._barcodeMode;

        // if (typed && !inHistoryMode && !inBarcodeMode && mapped.length > 1) {
        //   const isExact = (s) => {
        //     if (!s) return false;
        //     const a = s.trim().toLocaleLowerCase();
        //     return (
        //       a === typed ||
        //       a === typed + "(c)" ||
        //       a === typed + "(cr)" ||
        //       a === typed + "(cg)" ||
        //       a === typed + " sup(c)"
        //     );
        //   };
        //   const hitIdx = mapped.findIndex(it => isExact(it && it.fullname));
        //   if (hitIdx > 0) {
        //     const [hit] = mapped.splice(hitIdx, 1);
        //     mapped.unshift(hit);
        //   }
        // }

        if (typed && !inHistoryMode && !inBarcodeMode && mapped.length > 1) {
          const exactMatches = [];
          const others = [];

          for (const item of mapped) {
            const parsed = parseSuggestionName(item && item.fullname);
            if (parsed.base === typed) {
              exactMatches.push(item);
            } else {
              others.push(item);
            }
          }

          exactMatches.sort((a, b) => {
            const pa = parseSuggestionName(a && a.fullname);
            const pb = parseSuggestionName(b && b.fullname);

            // non-shared first, then Shared, Shared 1, Shared 2...
            return pa.sharedRank - pb.sharedRank;
          });

          mapped.splice(0, mapped.length, ...exactMatches, ...others);
        }

        this.setState({ data: mapped, showExpandedValueOverlay: false });
        if (this.state.show === false) {
          this.autoSelect();
        }
        this.props.onSuggestFinish && this.props.onSuggestFinish();
      });
    }

  async delaySearch(e) {
    clearTimeout(this.timer);
    this._fromHistoryClick = false; // safety: typing cancels history-mode guard
    this.setState({ data: [] });
    let newVal = e.target.value.trim();

    if (this.props.onChangeText) this.props.onChangeText(e.target.value);
    if (e.target && e.target.value) {
      setTimeout(() => {
        this.setState({ sval: newVal });
      }, 100);
    }
    this.timer = setTimeout(() => {
      if (this.state.sval == newVal && newVal.length > 0) {
        if (!this.props.append) {
          this.search(
            newVal.trim(),
            this.props.category,
            this.props.level,
            this.props.noUser,
            this.props.sType
          );
        }

        clearTimeout(this.timer);
      }
    }, 1000);
  }

  async internalSelect(item) {
    let partialSearch = this.props.partialResult;
    item.name = partialSearch && item.title;
    if (this.props.allergen) {
      var data = item;

      if (this.props.onSelect) this.props.onSelect(data);
      this._fromHistoryClick = false;
      this._justSelected = true;
      this.setState({ data: [], show: false, pendingSearch: false });
      if (typeof this.props.clearHistorySuggestions === "function") {
        this.props.clearHistorySuggestions();
      }

    } else if (this._barcodeMode && partialSearch && partialSearch.length > 0 && item.upc) {
      // 1️⃣ Fetch UPC data (service → returns data)
      const data = await barcodeService(item.upc, item.category);

      // 2️⃣ Trigger existing BARCODE_READ thunk (Redux + prompts)
      if (typeof this.props.barcodeSearch === "function") {
        this.props.barcodeSearch(item.upc, item.category, true, data);
      }

      // 3️⃣ Continue existing selection flow (DO NOT skip this)
      if (this.props.onSelect) {
        this.props.onSelect(data);
      }

      this._fromHistoryClick = false;
      this._justSelected = true;
      this._barcodeMode = false;

      this.setState({ data: [], show: false, pendingSearch: false });

      if (typeof this.props.clearHistorySuggestions === "function") {
        this.props.clearHistorySuggestions();
      }

    } else {
      var data = {};
      data = await getDetailService(
        item._id,
        this.props.cType ? this.props.cType : this.props.category,
        this.props.noUser,
        item.lang_id || false
      );

      if (this.props.onSelect) this.props.onSelect(data);
      this._fromHistoryClick = false;
      this._justSelected = true;
      this.setState({ data: [], show: false, pendingSearch: false });
      if (typeof this.props.clearHistorySuggestions === "function") {
        this.props.clearHistorySuggestions();
      }
    }

    setTimeout(() => {
      if (this.inputEl && document.activeElement === this.inputEl) {
        this.inputEl.blur();
      }
    }, 0);

  }

  componentDidMount() {
    const typed = String(this.props.val || "").trim();

    if (typed.length > 0 && !this.props.disabled && this.inputEl) {
      this.inputEl.focus();
      this.searchCurrentValueForNewCategory();
    }
  }

  componentDidUpdate(prevProps) {
    const prevCategory = String(prevProps.category || "").trim();
    const currCategory = String(this.props.category || "").trim();
    const currVal = String(this.props.val || "").trim();

    if (
      prevCategory !== currCategory &&
      currVal.length > 0 &&
      !this.props.disabled
    ) {
      if (this.inputEl && document.activeElement !== this.inputEl) {
        this.inputEl.focus();
      }

      this.searchCurrentValueForNewCategory();
      return;
    }

    const partialActive =
      this._barcodeMode &&
      Array.isArray(this.props.partialResult) &&
      this.props.partialResult.length > 0;

    // Open the dropdown when barcode/partial results arrive after a barcode click.
    // Only depends on _barcodeMode, so History state can't suppress it.
    if (
      this._barcodeMode &&
      Array.isArray(this.props.partialResult) &&
      this.props.partialResult.length > 0 &&
      (
        this.props.partialResult !== prevProps.partialResult
      )
    ) {
      this.setState({ show: true }, () => {
        if (this.inputEl && document.activeElement !== this.inputEl) {
          this.inputEl.focus();
        }
      });
    }

    // prefer objects (nameTotalOptions), fallback to strings (data)
    const incoming =
      (Array.isArray(this.props.nameTotalOptions) && this.props.nameTotalOptions) ||
      (Array.isArray(this.props.data) && this.props.data) ||
      null;

    const prevIncoming =
      (Array.isArray(prevProps.nameTotalOptions) && prevProps.nameTotalOptions) ||
      (Array.isArray(prevProps.data) && prevProps.data) ||
      null;

    // Don't let history mapping override the partial list visibility
    if (!partialActive && incoming !== prevIncoming && Array.isArray(incoming)) {
      const mapped = incoming.map(x =>
        typeof x === "string" ? { _id: x, fullname: x } : x
      );

      const shouldShow = mapped.length > 0;
      this.setState({ data: mapped, show: shouldShow, showExpandedValueOverlay: false }, () => {
        // Only refocus when there are items to show and we didn’t just select
        if (
          shouldShow &&
          !this._justSelected &&
          this.inputEl &&
          document.activeElement !== this.inputEl
        ) {
          this.inputEl.focus();
        }
      });
    }

    if (this.state.data) {
      if (this.state.pendingSearch === false) {
        if (this._suppressAutoSelectUntilRefocus) {
          return;
        }

        if (this._skipNextAutoSelect) {
          this._skipNextAutoSelect = false;
        } else {
          this.autoSelect();
        }
      }
    }

  }

  // autoSelect(immediate = false) {
  //   const snapshot = Array.isArray(this.state.data) ? [...this.state.data] : [];
    
  //   const run = () => {
  //     const hasData = snapshot.length > 0;
  //     if (!hasData) return;

  //     // 1) Early return when we opened via the history icon
  //     if (this._fromHistoryClick) return;

  //     // 2) Only autoselect when there is a typed value to match
  //     if (!this.props.val) return;

  //     const propVal = this.props.val.trim().toLocaleLowerCase();
  //     let selectedItem;
  //     for (const item of this.state.data) {
  //       if (!item && !item.fullname) continue;

  //       const normalizeAutoName = (s = "") =>
  //         String(s)
  //           .trim()
  //           .toLocaleLowerCase()
  //           .replace(/\s*-\s*shared(?:\s+\d+)?$/i, "")
  //           .replace(/\s+\((c|cr|cg)\)$/i, " ($1)")
  //           .replace(/\((c|cr|cg)\)$/i, " ($1)");

  //       // const itemName = item.fullname.trim().toLocaleLowerCase();

  //       const itemName = normalizeAutoName(item.fullname);
  //       const typedVal = normalizeAutoName(propVal);

  //       if (
  //         // itemName === propVal ||
  //         // itemName === propVal + "(c)" ||
  //         // itemName === propVal + "(cr)" ||
  //         // itemName === propVal + "(cg)" ||
  //         // itemName === propVal + " sup(c)"

  //         itemName === typedVal ||
  //         itemName === `${typedVal} (c)` ||
  //         itemName === `${typedVal} (cr)` ||
  //         itemName === `${typedVal} (cg)` ||
  //         itemName === `${typedVal} sup(c)`
  //       ) {
  //         selectedItem = item;
  //         break;
  //       }
  //     }
  //     if (selectedItem) {
  //       this.internalSelect(selectedItem);
  //       // 3) Only clear suggestions when we actually picked something
  //       this.setState({ data: [] });
  //     }
  //   // }, 150);
  //   };

  //   if (immediate) {
  //     run();
  //   } else {
  //     setTimeout(run, 150);
  //   }
  // }

  autoSelect(immediate = false) {
    const snapshot = Array.isArray(this.state.data) ? [...this.state.data] : [];

    const run = () => {
      const hasData = snapshot.length > 0;
      if (!hasData) return "none";

      // 1) Early return when we opened via the history icon
      if (this._fromHistoryClick) return "none";

      // 2) Only evaluate when there is a typed value
      const typedRaw = String(this.props.val || "").trim();

      if (!typedRaw) return "none";

      const perfectMatches = this.getPerfectMatches(snapshot, typedRaw);

      if (perfectMatches.length === 1) {
        this.internalSelect(perfectMatches[0]);
        this.setState({ data: [], show: false, pendingSearch: false });
        return "selected";
      }

      if (perfectMatches.length > 1) {
        this.showMultiplePerfectMatchesPrompt(snapshot);
        return "multiple";
      }

      return "none";
    };

    if (immediate) {
      return run();
    } else {
      setTimeout(run, 150);
      return "pending";
    }
  }

  _handleKeyDown = (e) => {
    if (e.key === "Enter" && this.state.data.length > 0) {
      this.autoSelect();
      this.setState({ pendingSearch: false });
    }
  };
  // _onBlure = (e) => {
  //   // If we just opened via the history icon, ignore this blur and keep the menu open
  //   if (this._fromHistoryClick) {
  //     // We've clicked the history icon — allow the blur to proceed normally
  //     this._fromHistoryClick = false;
  //     // Don’t force focus back in — just let autoSelect / closing happen
  //   }
  //   // IMPORTANT: run autoselect BEFORE checking _justSelected,
  //   this.autoSelect(true); // keep if you want exact-text autoselect; otherwise remove

  //   if (this._justSelected) {
  //     this._justSelected = false; // reset the guard
  //     setTimeout(() => {
  //       this.setState({ show: false, pendingSearch: false, data: [] });

  //       if (typeof this.props.clearHistorySuggestions === "function") {
  //         this.props.clearHistorySuggestions();
  //       }
  //     }, 300);
  //     return;
  //   }

  //   // Was the BARCODE suggestions list actually visible?
  //   const hadPartialVisible =
  //     this._barcodeMode &&
  //     Array.isArray(this.props.partialResult) &&
  //     this.props.partialResult.length > 0 &&
  //     this.state.show;

  //   this.setState({ show: false, pendingSearch: false, data: [] });
  //   // If the user is clicking away from an open barcode list, exit barcode mode now
  //   if (hadPartialVisible) {
  //     this._barcodeMode = false;
  //   }

  //   if (typeof this.props.clearHistorySuggestions === "function") {
  //     this.props.clearHistorySuggestions();
  //   }
  //   this.props.onRecipeNameBlur && this.props.onRecipeNameBlur(e);
  // };

  _onBlure = (e) => {
    this.hideExpandedOverlay();

    // If we just opened via the history icon, ignore this blur and keep the menu open
    if (this._fromHistoryClick) {
      this._fromHistoryClick = false;
    }

    // If user already chose from TAS, do not auto-select or prompt again
    if (this._justSelected) {
      this._justSelected = false;
      setTimeout(() => {
        this.setState({ show: false, pendingSearch: false, data: [] });

        if (typeof this.props.clearHistorySuggestions === "function") {
          this.props.clearHistorySuggestions();
        }
      }, 300);
      return;
    }

    const autoSelectResult = this.autoSelect(true);

    // Multiple perfect matches:
    // prompt is already shown inside autoSelect(), and list is restored after OK.
    if (autoSelectResult === "multiple") {
      this.props.onRecipeNameBlur && this.props.onRecipeNameBlur(e);
      return;
    }

    const hadPartialVisible =
      this._barcodeMode &&
      Array.isArray(this.props.partialResult) &&
      this.props.partialResult.length > 0 &&
      this.state.show;

    this.setState({ show: false, pendingSearch: false, data: [] });

    if (hadPartialVisible) {
      this._barcodeMode = false;
    }

    if (typeof this.props.clearHistorySuggestions === "function") {
      this.props.clearHistorySuggestions();
    }

    this.props.onRecipeNameBlur && this.props.onRecipeNameBlur(e);
  };

  shouldShowExpandedOverlay = () => {
    const value = String(this.props.val || "").trim();

    if (!value) return false;
    if (this.state.data && this.state.data.length > 0) return false;
    if (this.state.showMultipleMatchAlert) return false;
    if (this._barcodeMode) return false;
    if (this._fromHistoryClick) return false;
    if (!this.inputEl) return false;

    // Measure whether text actually overflows the visible input width
    const cs = window.getComputedStyle(this.inputEl);
    const font = [
      cs.fontStyle,
      cs.fontVariant,
      cs.fontWeight,
      cs.fontSize,
      cs.lineHeight === "normal" ? "" : `/${cs.lineHeight}`,
      cs.fontFamily,
    ]
      .filter(Boolean)
      .join(" ");

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return false;

    ctx.font = font;

    const textWidth = ctx.measureText(value).width;

    const inputWidth = this.inputEl.clientWidth || 0;
    const paddingLeft = parseFloat(cs.paddingLeft) || 0;
    const paddingRight = parseFloat(cs.paddingRight) || 0;

    const availableWidth = inputWidth - paddingLeft - paddingRight;

    return textWidth > availableWidth;
  };

  showExpandedOverlayIfEligible = () => {
    if (this.shouldShowExpandedOverlay()) {
      this.setState({ showExpandedValueOverlay: true });
    }
  };

  hideExpandedOverlay = () => {
    if (this.state.showExpandedValueOverlay) {
      this.setState({ showExpandedValueOverlay: false });
    }
  };

  render() {
    const {
      input,
      disabled,
      val,
      placeholder,
      showCross,
      bodyMapClicked,
      barcodeClicked,
      barcodeImageClicked,
      partialResult,
      showNoneOfAbove,
      showNoneOfAboveText,
    } = this.props;
    let value = val ? val.replace(/[\r\n]+/g, " ") : "";

    const isPromptOpen = this.state.showMultipleMatchAlert;
    
    const showClearX = !!(value && showCross);
    // Cross can also appear when there’s no value but an append suffix is shown
    const showXIcon = !!showCross && (!!value || !!this.props.append);
    const canShowRightIcons = !showClearX && !this.props.append;

    // Your existing conditions for barcode/paperclip (keep exactly how you gate them today)
    const showBarcode = canShowRightIcons && !!barcodeClicked;         // same guard you use now
    const showPaperclip = canShowRightIcons && !!barcodeClicked;       // same as your current paperclip block

    const hasCategory =
      this.props.category !== undefined &&
      this.props.category !== null &&
    String(this.props.category).trim() !== "";

    // Clock: available on Input page for all categories
    const showClock = canShowRightIcons && hasCategory && this.props.showHistory !== false;

    // Dynamic input padding so text doesn’t overlap ANY right-side adornments (rail, append, or ✕)
    const iconCount = (showClock ? 1 : 0) + (showPaperclip ? 1 : 0) + (showBarcode ? 1 : 0);
    let pr = this.props.append ? 30 : (12 + iconCount * 28); // base padding in px
    if (showXIcon) pr = Math.max(pr, 36); // reserve space for the ✕ (≈20px + insets)
    const inputPaddingRight = `${pr}px`;

    // Detect Body Map visibility using the same condition as the render block
    const showBodyMap = (!value && !!bodyMapClicked);

    // If Body Map is present, shift the right-rail left so it doesn't overlap
    const railRight = showBodyMap ? 30 : 10;   // 10px normally; 45px when body map occupies the far right

    // When only the clock is showing, nudge the rail slightly down for optical alignment
    const onlyClock = showClock && !showPaperclip && !showBarcode;
    const railTop = onlyClock ? "8px" : "6.4px";

    return (
      // <div className="vAutocomplete" style={{ position: "relative", borderRadius: "0.25rem", zIndex: 10 }}>
      <div
        className="vAutocomplete"
        style={{
          position: "relative",
          borderRadius: "0.25rem",
          zIndex: this.state.showMultipleMatchAlert ? 9999 : 10,
        }}
      >
        <InputGroup>
          <Input
            {...input}
            innerRef={(el) => (this.inputEl = el)}
            type="text"
            autoComplete="off"
            disabled={disabled}
            placeholder={placeholder}
            // onMouseDown={(e) => {
            //   if (
            //     this.inputEl &&
            //     document.activeElement === this.inputEl &&
            //     !this.state.showExpandedValueOverlay
            //   ) {
            //     e.preventDefault();
            //     this.showExpandedOverlayIfEligible();
            //   }
            // }}
            onChange={(val) => {
              // user started typing → leave history mode
              this._fromHistoryClick = false;
              this._skipNextAutoSelect = false;

              if (this.state.showExpandedValueOverlay) {
                this.setState({ showExpandedValueOverlay: false });
              }

              this.searchStatus("idle");
              this.delaySearch(val);
            }}
            value={value}
            onFocus={() => {
              if (this._restoringFocusAfterPrompt) {
                this._restoringFocusAfterPrompt = false;

                setTimeout(() => {
                  this._suppressAutoSelectUntilRefocus = false;
                }, 0);
              } else {
                this._suppressAutoSelectUntilRefocus = false;
              }

              this.setState({ show: true }, () => {
                this.showExpandedOverlayIfEligible();
              });
            }}
            onBlur={this._onBlure}
            style={{
              paddingRight: inputPaddingRight,
            }}
          />
          {this.props.append && (
            <div
              style={{
                backgroundColor: disabled ? "rgb(241, 243, 245)" : "#fff",
                position: "absolute",
                right: "30px",
                top: "4px",
                fontSize: "1rem",
                color: "#999",
                zIndex: 100,
                padding:
                  "0 5px",
                paddingHorizontal: 2,
                textAlign: "center",
                alignSelf: "center",
              }}
            >
              {`(${this.props.append})`}
            </div>
          )}
          {value && showCross ? (
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "2px",
                fontSize: "20px",
                color: "grey",
                cursor: disabled ? "default" : "pointer",
                zIndex: 100,
                padding: "0 5px",
              }}
            >
              <i
                className="fas fa-times"
                onClick={() => {
                  this.props.onClear && !disabled && this.props.onClear();
                }}
                style={{
                  color: disabled && "rgb(188,188,188)",
                }}
              ></i>
            </div>
          ) : (
            !value &&
            showCross &&
            this.props.append && (
              <div
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "2px",
                  fontSize: "20px",
                  color: "grey",
                  cursor: disabled ? "default" : "pointer",
                  zIndex: 100,
                  padding: "0 5px",
                }}
              >
                <i
                  className="fas fa-times"
                  onClick={() => {
                    this.props.onClear && !disabled && this.props.onClear();
                  }}
                  style={{
                    color: disabled && "rgb(188,188,188)",
                  }}
                ></i>
              </div>
            )
          )}

          {!value && bodyMapClicked && (
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "3.5px",
                fontSize: "20px",
                color: "grey",
                cursor: "pointer",
                zIndex: 90,
              }}
            >
              <i
                className="fas fa-male"
                style={{
                  color: disabled ? "#bbb" : "#007bff",
                  fontSize: "25px",
                  cursor: disabled ? "default" : "pointer",
                }}
                onClick={() => {
                  if (!disabled) {
                    bodyMapClicked();
                  }
                }}
              />
            </div>
          )}

          {/* // barcode */}
          {canShowRightIcons && (showClock || showPaperclip || showBarcode) && (
            <div
              className="va-right-icons"
              style={{
                position: "absolute",
                right: railRight,
                top: railTop,
                display: "flex",
                alignItems: "center",
                gap: 12,
                zIndex: 100,
              }}
            >
              {/* ⏳ CLOCK — always left-most in the rail */}
              {showClock && (
                <FontAwesomeIcon
                  icon={faArrowRotateLeft}
                  style={{
                    fontSize: 20,
                    top: "5.4px",
                    color: disabled ? "#bbb" : "#007bff",
                    cursor: disabled ? "default" : "pointer",
                  }}
                  onClick={() => {
                    if (disabled) return;

                    // mark that we opened via history and keep the list open
                    this._fromHistoryClick = true;

                    // keep focus & show
                    if (this.inputEl) this.inputEl.focus();
                    this.setState({ show: true });

                    // fire your thunk
                    if (typeof this.props.onHistoryClick === "function") {
                      this.props.onHistoryClick();
                    }
                  }}
                  />
                )}

              {/* 📎 PAPERCLIP (unchanged behavior, just rendered in the rail) */}
              {showPaperclip && (
                <FontAwesomeIcon
                  className="fas fa-paperclip"
                  icon={faPaperclip}
                  style={{
                    fontSize: 20,
                    color: disabled ? "#bbb" : "#007bff",
                    cursor: disabled ? "default" : "pointer",
                  }}
                  onClick={() => {
                    if (disabled) return;

                    // ✅ also bail out of history mode here
                    this._fromHistoryClick = false;
                    this._justSelected = false;
                    this.setState({ show: false, data: [], pendingSearch: false });

                    if (typeof this.props.clearHistorySuggestions === "function") {
                      this.props.clearHistorySuggestions();
                    }

                    if (this.inputEl && document.activeElement === this.inputEl) {
                      this.inputEl.blur();
                    }

                    barcodeImageClicked(); // your existing handler
                  }}
                />
              )}

              {/* 🧾 BARCODE (keep your existing icon/handler) */}
              {showBarcode && (
                <i
                  className="fas fa-barcode"
                  style={{
                    fontSize: 24,
                    color: disabled ? "#bbb" : "#007bff",
                    cursor: disabled ? "default" : "pointer",
                    lineHeight: 1,
                  }}
                  onClick={() => {
                    if (disabled) return;

                    // ✅ leave history mode and clear any history menu
                    this._fromHistoryClick = false;
                    this._justSelected = false;
                    this._barcodeMode = true;
                    this.setState({ show: false, data: [], pendingSearch: false });

                    // optional: clear Redux-held suggestions if parent provided the hook
                    if (typeof this.props.clearHistorySuggestions === "function") {
                      this.props.clearHistorySuggestions();
                    }

                    // Make sure the item name field is not focused while the modal opens
                    if (this.inputEl && document.activeElement === this.inputEl) {
                      this.inputEl.blur();
                    }

                    barcodeClicked(); // your existing handler

                  }}
                />
              )}
            </div>
          )}

        </InputGroup>

        {this.state.showExpandedValueOverlay && value && (
          <div
            onMouseDown={(e) => {
              e.preventDefault();

              // close overlay and return to the original field
              this.setState({ showExpandedValueOverlay: false }, () => {
                if (this.inputEl && document.activeElement !== this.inputEl) {
                  this.inputEl.focus();
                }
              });
            }}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              minHeight: "38px",
              height: "auto",
              overflow: "visible",
              padding: "0.375rem 0.75rem",
              paddingRight: inputPaddingRight,
              zIndex: 250,
              border: "1px solid #ced4da",
              borderRadius: "0.25rem",
              backgroundColor: disabled ? "rgb(241, 243, 245)" : "#fff",
              color: "#495057",
              fontSize: "1rem",
              fontFamily: "inherit",
              fontWeight: 400,
              lineHeight: "1.5",
              whiteSpace: "normal",
              wordBreak: "break-word",
              boxShadow: "none",
              cursor: disabled ? "default" : "text",
            }}
          >
            {value}
          </div>
        )}

        {!isPromptOpen && partialResult && partialResult.length > 0 && this._barcodeMode && this.state.show ? (
          <ul
            className={`${this.props.position == "top" ? "vAutoUl vAutoUlTop" : "vAutoUl"
              }`}
            style={{
              wordBreak: "break-word",
            }}
          >
            {partialResult.map((item) => {
              return (
                <li
                  key={item._id}
                  onMouseDown={(e) => { e.preventDefault(); }}
                  onClick={(e) => {
                    this.internalSelect(item, this.props.category);
                    this._barcodeMode = false;
                    this.setState({ data: [] });
                  }}
                >
                  {item.title}
                </li>
              );
            })}
            {showNoneOfAbove && (
              <li
                onMouseDown={(e) => { e.preventDefault(); }}  // keep input focused so blur doesn’t kill the click
                onClick={(e) => {
                  this.props.addCustomAlert();
                  this.setState({ data: [] });
                }}
              >
                {showNoneOfAboveText}
              </li>
            )}
          </ul>
        ) : (
          !isPromptOpen &&
          this.state.show &&
          this.state.data &&
          this.state.data.length > 0 && (
            <ul
              className={`${this.props.position == "top" ? "vAutoUl vAutoUlTop" : "vAutoUl"
                }`}
              style={{
                wordBreak: "break-word",
              }}
            >
              {this.state.data.map((item) => {
                return (
                  <li
                    key={item._id}
                    onTouchStart={(e) => e.preventDefault()} // For mobile
                    onMouseDown={(e) => {
                      e.preventDefault(); // keep input focused so onBlur doesn't fire before onClick/select
                    }}
                    onClick={() => {
                      this._justSelected = true; // tell blur handler this came from a menu click

                      this.internalSelect(item, this.props.category);

                      // clear suggestions, then blur the input on the next tick
                      this.setState({ data: [] }, () => {
                        setTimeout(() => {
                          if (this.inputEl && document.activeElement === this.inputEl) {
                            this.inputEl.blur(); // trigger blur AFTER selection is processed
                          }
                        }, 0);
                      });
                    }}
                  >
                    {item.fullname}
                  </li>
                );
              })}
            </ul>
          )
        )}

        <Valert
          display={this.state.showMultipleMatchAlert}
          title={i18n.t("general.MULTIPLE_MATCH_TITLE")}
          question={i18n.t("general.MULTIPLE_MATCH_TEXT")}
          positiveText={i18n.t("general.OK_PROMPT_TEXT")}
          readOnly={true}
          positiveAction={this.handleMultipleMatchPrompt}
        />

      </div>
    );
  }
}

export default VautoCompelete;



// WEBPACK FOOTER //
// ./src/components/VautoComplete.js